import React, { useEffect, useState } from "react";
import { Form, ListGroup, Row, Col, Button, Modal, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Axios from "axios";

//ACTIONS
import * as GlobalVarsActions from "../../../../../../../store/actions/globalVars";

//STYLES
import * as BookingApprovalStyles from "../styles/bookingApproval";

function BookingApproval() {
    const params = useParams();
    const dispatch = useDispatch();
    const [tab, setTab] = useState("users");
    const [data, setData] = useState({
        enabled: false,
        acceptedBy: "cod",
        rooms: "global",
        multiplePendings: false
    });
    const [users, setUsers] = useState([]);
    const [spUsers, setSpUsers] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [spRooms, setSpRooms] = useState([]);
    const [questions, setQuestions] = useState([]);

    const questionModalDefaults = {
        open: false,
        edit: false,
        editID: 0,
        question: "",
        touched: false,
        valid: false
    };
    const [questionModal, setQuestionModal] = useState(questionModalDefaults);

    function handleCloseQuestionModal() {
        setQuestionModal(questionModalDefaults);
    }

    const [modalYN, setModalYN] = useState({
        open: false,
        heading: "",
        message: "",
        acceptFunction: "",
        acceptName: "Yes",
        showAccept: false,
        cancelName: "No",
        showCancel: false
    });

    function handleModalYNClose() {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        dispatch(GlobalVarsActions.UpdateAdminMenuID("bookingApproval"));

        const data = { orgID: params.orgID };
        Axios.post("/orgAdmin/bookingApproval/loadData", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setData((prevState) => {
                        return {
                            ...prevState,
                            enabled: data.approval.enabled == "true",
                            acceptedBy: data.approval.users,
                            rooms: data.approval.rooms,
                            multiplePendings: data.approval.multiplePendings == "true"
                        };
                    });

                    if (data.approval.users == "spusers") {
                        fetchUsers();
                        fetchSpUsers();
                    }

                    if (data.approval.rooms == "global") {
                        fetchRooms();
                        fetchSpRooms();
                    }
                }
            })
            .catch((err) => console.log(err));
    }, []);

    function handleEnabledCheck(event) {
        const { checked } = event.target;
        const data = { orgID: params.orgID, enabled: checked.toString() };
        Axios.post("/orgAdmin/bookingApproval/updateEnabledApproval", data)
            .then((res) => {
                const data = res.data;
                setData((prevState) => {
                    return { ...prevState, enabled: checked };
                });
            })
            .catch((err) => console.log(err));
    }

    function fetchUsers() {
        const data = { orgID: params.orgID };
        Axios.post("/orgAdmin/users/getUsers", data)
            .then((res) => {
                const data = res.data;
                setUsers(data.users);
            })
            .catch((err) => console.log(err));
    }

    function fetchRooms() {
        const data = { orgID: params.orgID };
        Axios.post("/orgAdmin/rooms/getRooms", data)
            .then((res) => {
                const data = res.data;
                setRooms(data.rooms);
            })
            .catch((err) => console.log(err));
    }

    function fetchSpUsers() {
        const data = { orgID: params.orgID };
        Axios.post("/orgAdmin/bookingApproval/getSpUsers", data)
            .then((res) => {
                const data = res.data;
                setSpUsers(data.users);
            })
            .catch((err) => console.log(err));
    }

    function fetchSpRooms() {
        const data = { orgID: params.orgID };
        Axios.post("/orgAdmin/bookingApproval/getSpRooms", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                setSpRooms(data.rooms);
            })
            .catch((err) => console.log(err));
    }

    function handleChangeAcceptedBy(setting) {
        const data = { orgID: params.orgID, setting: setting };
        Axios.post("/orgAdmin/bookingApproval/updateUsers", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setData((prevState) => {
                        return { ...prevState, acceptedBy: setting };
                    });

                    if (setting == "spusers") {
                        fetchUsers();
                        fetchSpUsers();
                    }
                }
            })
            .catch((err) => console.log(err));
    }

    function handleMultiplePendings(event) {
        const { checked } = event.target;
        const data = { orgID: params.orgID, checked: checked };
        Axios.post("/orgAdmin/bookingApproval/multiplePendings", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setData((prevState) => {
                        return { ...prevState, multiplePendings: checked };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleChangeTab(tab) {
        setTab(tab);

        if (tab == "questions") {
            loadQuestions();
        }
    }

    function handleRoomsCheckboxChange(event) {
        const { checked } = event.target;
        let setting = "";

        if (checked) {
            setting = "userProfiles";
        } else {
            setting = "global";
            fetchRooms();
            fetchSpRooms();
        }

        const data = { orgID: params.orgID, setting: setting };
        Axios.post("/orgAdmin/bookingApproval/updateRooms", data).then((res) => {
            const data = res.data;
            if (data.error == "null") {
                setData((prevState) => {
                    return { ...prevState, rooms: setting };
                });
            }
        });
    }

    function handleSpuserListGroupClick(id) {
        const data = { uuid: id, approve: "true" };
        Axios.post("/orgAdmin/bookingApproval/updateUserApprove", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    fetchSpUsers();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleRoomListGroupClick(id) {
        const data = { uuid: id, approve: "true" };
        Axios.post("/orgAdmin/bookingApproval/updateRoomApprove", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    fetchSpRooms();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleSpuserListGroupUnClick(id) {
        const data = { uuid: id, approve: "false" };
        Axios.post("/orgAdmin/bookingApproval/updateUserApprove", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    fetchSpUsers();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleRoomListGroupUnClick(id) {
        const data = { uuid: id, approve: "false" };
        Axios.post("/orgAdmin/bookingApproval/updateRoomApprove", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    fetchSpRooms();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOpenQuestionModal() {
        setQuestionModal((prevState) => {
            return { ...prevState, open: true };
        });
    }

    function handleQuestionTextChange(event) {
        const { value } = event.target;

        let isValid = false;

        if (value.length > 0) {
            isValid = true;
        }

        setQuestionModal((prevState) => {
            return { ...prevState, question: value, valid: isValid };
        });
    }

    function loadQuestions() {
        const data = { orgID: params.orgID };
        Axios.post("/orgAdmin/bookingApproval/getQuestions", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setQuestions(data.questions);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleQuestionOnTouched() {
        setQuestionModal((prevState) => {
            return { ...prevState, touched: true };
        });
    }

    function handleQuestionModalSubmit() {
        if (!questionModal.valid) {
            setQuestionModal((prevState) => {
                return { ...prevState, touched: true };
            });
        } else {
            const data = { orgID: params.orgID, question: questionModal.question };
            Axios.post("/orgAdmin/bookingApproval/addQuestion", data)
                .then((res) => {
                    const data = res.data;
                    if (data.error == "null") {
                        setQuestionModal(questionModalDefaults);
                        loadQuestions();
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    function handleEditQuestion(questionUUID, question) {
        let isValid = false;
        if (question.length > 0) {
            isValid = true;
        }

        setQuestionModal((prevState) => {
            return { ...prevState, open: true, edit: true, editID: questionUUID, question: question, touched: true, valid: isValid };
        });
    }

    function handleUpdateQuestionSubmit() {
        const data = { questionUUID: questionModal.editID, question: questionModal.question };
        Axios.post("/orgAdmin/bookingApproval/updateQuestion", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setQuestionModal(questionModalDefaults);
                    loadQuestions();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleStartDeleteQuestion(questionUUID) {
        setModalYN((prevState) => {
            return {
                ...prevState,
                heading: "Delete Question?",
                message: "Are you sure you want to delete this question?",
                showAccept: true,
                acceptName: "Yes",
                acceptFunction: handleDeleteAcceptence.bind(this, questionUUID),
                showCancel: true,
                open: true
            };
        });
    }

    function handleDeleteAcceptence(questionUUID) {
        const data = { orgID: params.orgID, questionUUID: questionUUID };
        Axios.post("/orgAdmin/bookingApproval/deleteQuestion", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setQuestionModal(questionModalDefaults);
                    loadQuestions();
                    handleModalYNClose();
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={BookingApprovalStyles.body}>
            <Form.Check type="checkbox" label="Enable Booking Approval" checked={data.enabled} onChange={handleEnabledCheck} />
            <br />
            {data.enabled && (
                <div>
                    <div>
                        <Row>
                            <Col style={BookingApprovalStyles.topButtonColumn}>
                                <div
                                    style={tab == "users" ? BookingApprovalStyles.topButtonSelected : BookingApprovalStyles.topButtons}
                                    onClick={handleChangeTab.bind(this, "users")}
                                >
                                    Users
                                </div>
                            </Col>
                            <Col style={BookingApprovalStyles.topButtonColumn}>
                                <div
                                    style={tab == "rooms" ? BookingApprovalStyles.topButtonSelected : BookingApprovalStyles.topButtons}
                                    onClick={handleChangeTab.bind(this, "rooms")}
                                >
                                    Rooms
                                </div>
                            </Col>
                            <Col style={BookingApprovalStyles.topButtonColumn}>
                                <div
                                    style={tab == "questions" ? BookingApprovalStyles.topButtonSelected : BookingApprovalStyles.topButtons}
                                    onClick={handleChangeTab.bind(this, "questions")}
                                >
                                    Questions
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {tab == "users" && (
                        <div style={BookingApprovalStyles.tabContainer}>
                            <Form.Check
                                type="radio"
                                label="Approval Requests should be accepted by the Contact of the Department"
                                checked={data.acceptedBy == "cod"}
                                onChange={handleChangeAcceptedBy.bind(this, "cod")}
                            />
                            <Form.Check
                                type="radio"
                                label="Approval Requests should be accepted by the users below"
                                checked={data.acceptedBy == "spusers"}
                                onChange={handleChangeAcceptedBy.bind(this, "spusers")}
                            />
                            <br />
                            <Form.Check
                                label="Enable multiple pending bookings"
                                disabled
                                checked={data.multiplePendings}
                                onChange={handleMultiplePendings}
                            />
                            {data.acceptedBy == "cod" && (
                                <div style={BookingApprovalStyles.tabContainer}>
                                    <div style={BookingApprovalStyles.contactOfDepartmentText}>
                                        Please assign Department Contacts in the Depertments tab
                                    </div>
                                </div>
                            )}
                            {data.acceptedBy == "spusers" && (
                                <div style={BookingApprovalStyles.tabContainer}>
                                    <Row>
                                        <Col>
                                            <div style={BookingApprovalStyles.usersContainer}>
                                                <ListGroup>
                                                    {users.map((user, index) => {
                                                        return (
                                                            <ListGroup.Item
                                                                key={index}
                                                                action
                                                                onClick={handleSpuserListGroupClick.bind(this, user.uuid)}
                                                            >
                                                                {user.displayName}
                                                            </ListGroup.Item>
                                                        );
                                                    })}
                                                </ListGroup>
                                            </div>
                                        </Col>
                                        <Col>
                                            {spUsers.map((user, index) => {
                                                return (
                                                    <div key={index}>
                                                        <Row>
                                                            <Col
                                                                sm={"auto"}
                                                                style={BookingApprovalStyles.spUserCross}
                                                                onClick={handleSpuserListGroupUnClick.bind(this, user.uuid)}
                                                            >
                                                                <i className="fa-solid fa-xmark fa-xl"></i>
                                                            </Col>
                                                            <Col>{user.displayName}</Col>
                                                        </Row>
                                                    </div>
                                                );
                                            })}
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </div>
                    )}
                    {tab == "rooms" && (
                        <div style={BookingApprovalStyles.tabContainer}>
                            <Form.Check
                                label="Use User Profiles to assign booking approvals to rooms"
                                checked={data.rooms != "global"}
                                onChange={handleRoomsCheckboxChange}
                            />
                            {data.rooms == "global" && (
                                <div>
                                    <div style={BookingApprovalStyles.tabContainer}>
                                        <Row>
                                            <Col>
                                                <div style={BookingApprovalStyles.usersContainer}>
                                                    <ListGroup>
                                                        {rooms.map((room, index) => {
                                                            return (
                                                                <ListGroup.Item
                                                                    key={index}
                                                                    action
                                                                    onClick={handleRoomListGroupClick.bind(this, room.uuid)}
                                                                >
                                                                    {room.name}
                                                                </ListGroup.Item>
                                                            );
                                                        })}
                                                    </ListGroup>
                                                </div>
                                            </Col>
                                            <Col>
                                                {spRooms.map((room, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <Row>
                                                                <Col
                                                                    sm={"auto"}
                                                                    style={BookingApprovalStyles.spUserCross}
                                                                    onClick={handleRoomListGroupUnClick.bind(this, room.uuid)}
                                                                >
                                                                    <i className="fa-solid fa-xmark fa-xl"></i>
                                                                </Col>
                                                                <Col>{room.name}</Col>
                                                            </Row>
                                                        </div>
                                                    );
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            )}
                            {data.rooms == "userProfiles" && (
                                <div style={BookingApprovalStyles.tabContainer}>
                                    <div style={BookingApprovalStyles.featureText}>This feature is not built yet.</div>
                                </div>
                            )}
                        </div>
                    )}
                    {tab == "questions" && (
                        <div>
                            <Row>
                                <Col>
                                    Each question needs to be a maximum of 100 charcters long. <br /> Each answer can be up to 200 charcters
                                    long.{" "}
                                </Col>
                                <Col style={BookingApprovalStyles.columnRight}>
                                    <Button onClick={handleOpenQuestionModal}>Add Question</Button>
                                </Col>
                            </Row>
                            <br />
                            {questions.map((question, index) => {
                                return (
                                    <div key={index}>
                                        <Card>
                                            <Card.Body>
                                                <Row>
                                                    <Col>
                                                        {question.questionNo}. {question.question}
                                                    </Col>
                                                    <Col style={BookingApprovalStyles.columnRight}>
                                                        <Button onClick={handleEditQuestion.bind(this, question.uuid, question.question)}>
                                                            <i className="fas fa-edit"></i>
                                                        </Button>
                                                        <Button onClick={handleStartDeleteQuestion.bind(this, question.uuid)}>
                                                            <i className="fas fa-trash-alt"></i>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                        <br />
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}
            <Modal show={questionModal.open} onHide={handleCloseQuestionModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{questionModal.edit ? "Edit Question" : "Add Question"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Question:</Form.Label>
                        <Form.Control
                            isInvalid={questionModal.touched && !questionModal.valid ? true : false}
                            as="textarea"
                            rows={2}
                            maxLength={100}
                            value={questionModal.question}
                            onChange={handleQuestionTextChange}
                            onBlur={handleQuestionOnTouched}
                        />
                        <Form.Control.Feedback type="invalid">Please enter a question!</Form.Control.Feedback>
                    </Form.Group>
                    <div style={BookingApprovalStyles.questionCounter}>{100 - questionModal.question.length}</div>
                </Modal.Body>
                <Modal.Footer>
                    {questionModal.edit ? (
                        <Button onClick={handleUpdateQuestionSubmit}>Update</Button>
                    ) : (
                        <Button onClick={handleQuestionModalSubmit}>Add</Button>
                    )}
                    <Button onClick={handleCloseQuestionModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={modalYN.open} onHide={handleModalYNClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalYN.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalYN.message}</Modal.Body>
                <Modal.Footer>
                    {modalYN.showAccept ? (
                        <div>
                            <Button variant="primary" onClick={modalYN.acceptFunction}>
                                {modalYN.acceptName}
                            </Button>
                        </div>
                    ) : null}
                    {modalYN.showCancel ? (
                        <div>
                            <Button variant="primary" onClick={handleModalYNClose}>
                                {modalYN.cancelName}
                            </Button>
                        </div>
                    ) : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default BookingApproval;
